export const headersDocumentos = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 5, key: 'status' },
  { text: 'Localizador', width: 10, key: 'localizador' },
  { text: 'Data da Criação', width: 10, key: 'dataCriacao' },
  { text: 'Tipo de Documento', width: 15, key: 'tipoDocumento' },
  { text: 'Extensão Arq.', width: 7, key: 'extensaoDocumento' },

  { text: 'Título', width: 60, key: 'denominacaoGenerica' },
];

export const valoresExibidosDocumentosSisAF: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorObservacoes: '',

  //Específicos
  statusDoc: 'Status',
  localizador: 'Localizador',
  dataCriacao: 'Data da Criação',
  tipoDocumento: 'Tipo de Documento',
  extensaoDocumento: 'Extensão do Arquivo',
  responsavelDocumento: 'Responsável',
  titulo: 'Título',
  resumo: 'Resumo',
  link: 'Link',
};

export const fieldObjectDocumentos = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
